import moment from 'moment-timezone'
import { useSelector } from 'react-redux'
import { useCallback, useEffect, useMemo, useState } from 'react'
import './SelectModePopUp.scss'
import { PopUp, PrimaryButton } from 'ui_kit_qmd'
import { isEmpty } from 'lodash'
import { SecondaryButton } from '../../../components/ui_kit_quickMD/secondary-button/secondarybutton'
import closeIcon from '../../../images/common/close.png'
import { generateStatesAbbrArrayFromStateFullNamesArray, getDaysOfWeekFromAbbreviationArr } from '../../../utils/common'
import { transformToUTCValidFormat } from '../AvailabilityPopUp/helper'
import { DATE_TIME_ISO_FORMAT } from '../../../utils/dateUtils'

const popUpContainerStyle = {
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  zIndex: 9999999999,
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'auto',
  maxHeight: '100%',
}
const popUpBoxStyle = {
  padding: '54px 74.5px 56px 74.5px',
  backgroundColor: '#ffffff',
  borderRadius: 4,
  width: 776,
  height: 278,
  position: 'relative',
}

const secondaryBtnContainerStyle = {
  height: 60,
  width: 245,
  border: '1px solid #00A2B2',
  padding: 0,
}
const secondaryBtnLabelStyle = {
  fontSize: 20,
  fontWeight: 700,
  gap: 10,
  letterSpacing: 1.5,
}
const primaryBtnContainerStyle = {
  height: 60,
  width: 245,
  marginLeft: 24,
}
const primaryBtnLabelStyle = {
  fontSize: 20,
  gap: 10,
  letterSpacing: 1.5,
}
const SelectModePopUp = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsSelectModePopUp,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  clickedStartDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  clickedEndDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  occurrenceId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  occurrenceOrder,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  scheduleId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  viewType,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  recurrenceEndDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  editScheduleHandler,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  availableStatesCodesArray,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  initialAvailableStateCodes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  providerAvailableStates,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  daysOfWeekRef,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypeGroupId,
}) => {
  const [selectedOption, setSelectedOption] = useState([
    { value: 'This event only', isChecked: true },
    { value: 'This and following events', isChecked: false },
  ])

  const isAllAvailableStatesIsSelected = availableStatesCodesArray.length === providerAvailableStates.length

  const statesCodesField = useMemo(
    () => ({
      StateCodes:
        viewType.includes('availability') && !isAllAvailableStatesIsSelected ?
          generateStatesAbbrArrayFromStateFullNamesArray(availableStatesCodesArray)
        : [],
    }),
    [availableStatesCodesArray, isAllAvailableStatesIsSelected, viewType],
  )
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const scheduleInfoFrom = useSelector((state) => state.calendarPageReducer.scheduleInfoFrom)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const scheduleInfoTo = useSelector((state) => state.calendarPageReducer.scheduleInfoTo)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const recurringBaseTimeZone = useSelector((state) => state.calendarPageReducer.recurringBaseTimeZone)

  const [selectedOptionValue, setSelectedOptionValue] = useState('This event only')

  useEffect(() => {
    if (selectedOption) {
      // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
      setSelectedOptionValue(selectedOption.find((option) => option.isChecked).value)
    }
  }, [selectedOption])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onToggleSelectMode = (value) => {
    setSelectedOption((prev) => prev.map((t) => ({ ...t, isChecked: t.value === value })))
  }

  const onPressSafeHandler = useCallback(() => {
    const daysOfWeekList = getDaysOfWeekFromAbbreviationArr(daysOfWeekRef?.current?.getActiveDays())
    switch (selectedOptionValue) {
      case 'This event only': {
        const editOccurrenceRequestBody = {
          TimeZone: recurringBaseTimeZone,
          Occurrences: {
            Edit: [
              {
                VisitTypeGroupId: visitTypeGroupId,
                OccurrenceId: occurrenceId,
                ScheduleId: scheduleId,
                FromDateTime: transformToUTCValidFormat(clickedStartDateTime.dateTime),
                ToDateTime: transformToUTCValidFormat(clickedEndDateTime.dateTime),
                ...statesCodesField,
              },
            ],
          },
        }
        editScheduleHandler(editOccurrenceRequestBody, null)
        setIsSelectModePopUp(false)
        break
      }
      case 'This and following events': {
        if (occurrenceOrder === 0) {
          const requestEditFirstOccurrenceInScheduleBody = {
            TimeZone: recurringBaseTimeZone,
            Schedules: {
              Edit: [
                {
                  VisitTypeGroupId: visitTypeGroupId,
                  ScheduleId: scheduleId,
                  FromDateTime: transformToUTCValidFormat(clickedStartDateTime.dateTime),
                  ToDateTime: transformToUTCValidFormat(clickedEndDateTime.dateTime),
                  ...statesCodesField,
                  Type: viewType.includes('availability') ? 'availability' : 'unavailability',
                  RecurringSettings: {
                    EndDateTime: isEmpty(recurrenceEndDateTime.dateTime) ? null : recurrenceEndDateTime.dateTime,
                    WeekDays: daysOfWeekList,
                  },
                },
              ],
            },
          }
          editScheduleHandler(
            requestEditFirstOccurrenceInScheduleBody,
            viewType.includes('availability') ? 'availability' : 'unavailability',
          )
        } else {
          const requestEditNonFirstOccurrenceInScheduleBody = {
            TimeZone: recurringBaseTimeZone,
            Schedules: {
              Create: [
                {
                  VisitTypeGroupId: visitTypeGroupId,
                  FromDateTime: transformToUTCValidFormat(clickedStartDateTime.dateTime),
                  ToDateTime: transformToUTCValidFormat(clickedEndDateTime.dateTime),
                  ...statesCodesField,
                  Type: viewType.includes('availability') ? 'availability' : 'unavailability',
                  RecurringSettings: {
                    EndDateTime: isEmpty(recurrenceEndDateTime.dateTime) ? null : recurrenceEndDateTime.dateTime,
                    WeekDays: daysOfWeekList,
                  },
                },
              ],
              Edit: [
                {
                  VisitTypeGroupId: visitTypeGroupId,
                  ScheduleId: scheduleId,
                  FromDateTime: scheduleInfoFrom,
                  ToDateTime: scheduleInfoTo,
                  ...(viewType.includes('availability') ? { StateCodes: initialAvailableStateCodes } : {}),
                  RecurringSettings: {
                    EndDateTime: moment(clickedStartDateTime.dateTime).subtract(1, 'days').format(DATE_TIME_ISO_FORMAT),
                    WeekDays: daysOfWeekList,
                  },
                },
              ],
            },
          }
          editScheduleHandler(requestEditNonFirstOccurrenceInScheduleBody)
        }
        setIsSelectModePopUp(false)
        break
      }
      default:
        break
    }
  }, [
    clickedEndDateTime.dateTime,
    clickedStartDateTime.dateTime,
    daysOfWeekRef,
    editScheduleHandler,
    initialAvailableStateCodes,
    occurrenceId,
    occurrenceOrder,
    recurrenceEndDateTime.dateTime,
    recurringBaseTimeZone,
    scheduleId,
    scheduleInfoFrom,
    scheduleInfoTo,
    selectedOptionValue,
    setIsSelectModePopUp,
    statesCodesField,
    viewType,
  ])

  const onCloseSelectModePopUp = useCallback(() => {
    setIsSelectModePopUp(false)
  }, [setIsSelectModePopUp])

  return (
    <PopUp
      popUpContainerStyle={popUpContainerStyle}
      popUpBoxStyle={popUpBoxStyle}
      content={
        <div className='select-mode-container'>
          <div>
            <div className='select-mode-title'>Edit recurring event</div>
            <img
              role='presentation'
              alt='Close'
              src={closeIcon}
              className='select-mode-close-icon'
              onClick={onCloseSelectModePopUp}
            />
            {selectedOption.map((t, i) => (
              <div key={t.value} className='mode-option-container' style={{ marginBottom: i === 0 ? 38 : 31 }}>
                {}
                <label className='radio'>
                  <input onChange={() => onToggleSelectMode(t.value)} type='radio' checked={t.isChecked} />
                  <div
                    className='radioBtnCircle'
                    style={{ border: t.isChecked ? '1px solid #00A2B2' : '1px solid #141414' }}
                  />
                  <div className='mode-option-value'>{t.value}</div>
                </label>
              </div>
            ))}
            <div className='select-mode-btn-mode'>
              {/*
               // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
              <SecondaryButton
                id='viewServiceCancelEditBtn'
                btnText='Cancel'
                containerStyle={secondaryBtnContainerStyle}
                labelStyle={secondaryBtnLabelStyle}
                onPress={onCloseSelectModePopUp}
              />
              <PrimaryButton
                btnText='Save'
                id='viewServiceSaveEditBtn'
                containerStyle={primaryBtnContainerStyle}
                labelStyle={primaryBtnLabelStyle}
                onPress={onPressSafeHandler}
              />
            </div>
          </div>
        </div>
      }
    />
  )
}

export default SelectModePopUp
